import { useMutation, useQuery } from '@apollo/client';
import {
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  ThemeProvider,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { gql, loader } from 'graphql.macro';
import React, { FunctionComponent, useState } from 'react';
import { loaderTheme } from '../../../support/Utils';
import { User } from '../components/InputUser';
import LoadingConfig from '../components/LoadingConfig';

const getAssistentesPcpLinxQuery = gql`
  query getAssistentesPcpLinx {
    getResponsaveisPcp {
      responsavel_pcp
      Usuario_Relacionado {
        id_usuario
        login
      }
    }
  }
`;
const headerClass = 'caption bold neutral500 uppercase';

const updateUserAssistentePcp = gql`
  mutation updateUserAssistentePcp($idUsuario: Float!, $responsavel: String!) {
    updateOneAssistente_Pcp(
      where: { responsavel_pcp: $responsavel }
      data: { Usuario: { set: { id_usuario: $idUsuario } } }
    ) {
      id_assistente_pcp
    }
  }
`;

const ResponsavelPpcRow: FunctionComponent<{
  row: AssistentePcpRow;
  users: User[];
}> = ({ row, users }) => {
  const selectedUser =
    users.find(
      (user) => user.id_usuario === row.Usuario_Relacionado?.id_usuario
    ) || ({} as User);
  const [value, setValue] = useState<User>(selectedUser);
  const [save, { loading }] = useMutation(updateUserAssistentePcp);
  return (
    <TableRow>
      <TableCell>{row.responsavel_pcp}</TableCell>
      <TableCell>
        <Autocomplete
          options={users}
          value={value}
          closeIcon={null}
          onChange={(_, newValue) => {
            setValue(newValue || ({} as User));
          }}
          getOptionSelected={(option, value) =>
            option.id_usuario === value.id_usuario
          }
          getOptionLabel={(option) => {
            return option.login || '';
          }}
          fullWidth
          renderInput={(params) => (
            <TextField {...params} variant='outlined' size='small' fullWidth />
          )}
        />
      </TableCell>
      <TableCell>
        <Button
          variant='contained'
          className='backgroundPrimary500'
          onClick={() => {
            save({
              variables: {
                idUsuario: value.id_usuario,
                responsavel: row.responsavel_pcp,
              },
            });
          }}
          disabled={loading}
          fullWidth
        >
          {loading ? (
            <ThemeProvider theme={loaderTheme}>
              <CircularProgress size={25} color='primary'></CircularProgress>
            </ThemeProvider>
          ) : (
            <span className='text-transform-initial body2 bold primary100'>
              Salvar
            </span>
          )}
        </Button>
      </TableCell>
    </TableRow>
  );
};

type AssistentePcpRow = {
  responsavel_pcp: string;
  Usuario_Relacionado?: User;
};

const queryUsers = loader('../../../support/queries/GetUserForMentionsOnlyActive.gql');

const ResponsavelPCP: FunctionComponent = () => {
  const {
    loading: loadingAssistentes,
    data = { getResponsaveisPcp: [] },
  } = useQuery<{
    getResponsaveisPcp: AssistentePcpRow[];
  }>(getAssistentesPcpLinxQuery);

  const {
    loading: loadingUsers,
    data: dataUsers = { findManyUsuario: [] },
  } = useQuery<{
    findManyUsuario: User[];
  }>(queryUsers);

  const loading = loadingAssistentes || loadingUsers;
  return (
    <div style={{ width: '50%' }}>
      {loading ? (
        <LoadingConfig></LoadingConfig>
      ) : (
        <div>
          <Table aria-label='simple table'>
            <TableHead>
              <TableRow className='tableHeader'>
                <TableCell className={headerClass}>
                  Responsável PCP
                </TableCell>
                <TableCell className={headerClass}>Usuário</TableCell>
                <TableCell className={headerClass}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className='backgroundNeutral50'>
              {data.getResponsaveisPcp.map((item) => {
                return (
                  <ResponsavelPpcRow
                    key={`responsavel-${item.responsavel_pcp}`}
                    row={item}
                    users={dataUsers.findManyUsuario}
                  ></ResponsavelPpcRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default ResponsavelPCP;
